import {FC, useEffect, useState, useMemo} from 'react'
import {useFormContext, useWatch} from 'react-hook-form'
import {InputNumberDoc} from '../../../../../components/UI/Input'
import {Select} from '../../../../../components/UI/Select'
import {useAuth} from '../../../../../hooks/useAuth'
import {ShowSnackBar} from '../../../../../util/functions'
import {getTyPeDocumentSite} from '../../../../central/services'
import {getCheckingService2, searchGuestService} from '../../../services/checking.service'
import {getMasterModuleService} from '../../modules/services'
import {getAllUserV2} from '../../guests/services'
import AsyncSelect from 'react-select/async'
import debounce from 'debounce'
import moment from 'moment'
interface Props {
  prevStep: () => void
  nextStep: () => void
  stepper: any
  goToFirstStep: () => void
  goToStep: (index: number) => void
}

const FormStep2: FC<Props> = ({prevStep, nextStep, stepper, goToFirstStep, goToStep}) => {
  const {user} = useAuth()
  const {
    register,
    setValue,
    watch,
    control,
    formState: {errors},
    // setError,
  } = useFormContext()
  // const [timer, setTimer] = useState(30)
  // const [docType, setDocType] = useState<any[]>([])
  const [searching, setSearching] = useState(false)
  // const [, setMaxLength] = useState(0)
  const tipoDocumento = useWatch({name: 'tipoDocumentoId'})
  const operationType = useWatch({name: 'operationType'})
  const numeroDocumento = useWatch({name: 'numeroDocumento'})
  const validateString = useWatch({name: 'validateString'})
  const docType = useWatch({name: 'doctypes'})
  const [processedDocument, setProcessedDocument] = useState<string | null>(null)
  const fromStep1 = useWatch({name: 'fromStep1'})
  const [selectedGuest, setSelectedGuest] = useState<any>(null)
  let numeroDocumentoChangeTimeout: any

  // useEffect(() => {
  //   // Start the timer countdown when the component mounts
  //   const intervalId = setInterval(() => {
  //     setTimer((prevTimer) => (prevTimer > 0 ? prevTimer - 1 : 0))
  //   }, 1000)

  //   // Clean up the interval when the component unmounts
  //   return () => clearInterval(intervalId)
  // }, [])

  // useEffect(() => {
  //   // Perform an action when the timer reaches 0
  //   if (timer === 0) {
  //     // Assuming you have access to stepper.current in the scope of this component
  //     // Replace this with your actual logic to go to step 1
  //     //   stepper.current.goto(1)
  //     goToFirstStep()
  //   }
  // }, [timer])

  useEffect(() => {
    // getValueTypeDocumentBySite()
    setValue('numeroDocumento', '')
    setValue('isGuest', false)
    setValue('AceptaTyC', false)
    setValue('tipoDocumento_descripcion', '')
    setValue('HuespedId', '')
    setValue('CamaId', '')
    setValue('ReservaId', '')
    setValue('Estado', '')
    setValue('bookingItem', {})
    setValue('hasBookings', false)
    setSelectedGuest(null) // Limpiar la selección de huésped
  }, [])

  // const handleGetMaxLength = (val: any) => {
  //   const value = val ? val : ''

  //   setMaxLength(value.length)
  //   setValue('tipoDocumentoId', value.value)
  //   setValue('tipoDocumento_descripcion', value.label)
  //   setValue('numeroDocumento', '')
  //   setError('tipoDocumentoId', {})
  //   setError('numeroDocumento', {})
  // }

  const configDocString = (
    cadena: string,
    valorBase: string,
    direccion: 'IZQ' | 'DER',
    tipoDato: 'NUM' | 'ALF',
  ): string => {
    const newCadena = cadena.toLowerCase()
    const newValorBase = valorBase.toLowerCase()
    const index = newCadena.indexOf(newValorBase)

    if (index === -1) {
      return ''
    }
    const parteRelevante =
      direccion === 'IZQ' ? cadena.slice(0, index) : cadena.slice(index + valorBase.length)

    const regex = tipoDato === 'NUM' ? /\d+/g : /[a-zA-Z0-9]+/g

    const coincidencias = parteRelevante.match(regex)

    const resultados = coincidencias ? coincidencias.join('') : ''

    return resultados
  }

  const configDocStringExpresion = (expression: string, cadena: string) => {
    try {
      const regex = new RegExp(expression, 'g')
      const matches = cadena.match(regex)
      return matches ? matches.join('') : null
    } catch (error) {
      console.log('Error en la expresión regular:')
      return null
    }
  }

  const handleGetPerson = (e: any) => {
    let value = e.target.value
    setValue('numeroDocumento', value)
  }

  // Función para cargar opciones de huéspedes con autocompletado
  const debouncedLoadOptions = useMemo(() => {
    const load = (inputValue: string, callback: any) => {
      if (!inputValue || inputValue.length < 3) {
        callback([])
        return
      }
      const loadOptions = async () => {
        try {
          const {data: response} = await getAllUserV2({
            isCombo: true,
            BuscaTexto: inputValue,
          })
          if (!response.error && response.data) {
            const mappedGuests = response.data
              .filter((guest: any) => guest && guest.id)
              .map((guest: any) => {
                const nombres = guest.nombres || ''
                const apellidos = guest.apellidos || ''
                const label =
                  `${nombres} ${apellidos}`.trim() || 'Sin nombre'

                return {
                  value: guest.id,
                  label: label,
                  guestData: guest, // Guardamos los datos completos del huésped
                }
              })

            if (callback && typeof callback === 'function') {
              callback(mappedGuests)
            }
          } else {
            if (callback && typeof callback === 'function') {
              callback([])
            }
          }
        } catch (error) {
          console.error('Error fetching guests:', error)
          if (callback && typeof callback === 'function') {
            callback([])
          }
        }
      }

      loadOptions()
    }

    return debounce(load, 500)
  }, [])

  // Limpiar el debounce al desmontar
  useEffect(() => {
    return () => {
      if (debouncedLoadOptions && typeof debouncedLoadOptions.clear === 'function') {
        debouncedLoadOptions.clear()
      }
    }
  }, [debouncedLoadOptions])

  // Manejar la selección de un huésped
  const handleGuestSelect = (selectedOption: any) => {
    if (selectedOption && selectedOption.guestData) {
      const guest = selectedOption.guestData
      // Setear el DNI, tipo de documento y descripción del tipo de documento
      if (guest.numeroDocumento) {
        setValue('numeroDocumento', guest.numeroDocumento)
      }
      setSelectedGuest(selectedOption)
    } else {
      setSelectedGuest(null)
    }
  }

  const getChekings = async (tipoDocumento, numeroDocumento) => {
    setValue('loadingBooking', true)
    try {
      const {data: response} = await getCheckingService2({
        pageNumber: 1,
        size: 100,
        StatusCode: operationType === 'checkin' ? '2,8' : '3', //Checking
        TipoDocumentoId: tipoDocumento,
        NumeroDocumento: numeroDocumento,
      })
      if (response.data.length > 0) {
        const list = response.data
        let mainItem: any = list[0]
        let previousItem: any = null

        // En checkout con 2 o más reservas, se ordena por FechaCheckIn de la más cercana a
        // hoy hacia atrás (fecha más reciente primero): la 1ra se pinta en el detalle de
        // reserva y la 2da (segunda más cercana) se reserva para el modal de checkout previo.
        if (operationType === 'checkout' && list.length >= 2) {
          const timeValue = (item: any) => {
            const date = moment(
              item?.FechaCheckIn,
              ['DD/MM/YYYY HH:mm', 'DD/MM/YYYY', 'YYYY-MM-DD', moment.ISO_8601],
              true
            )
            return date.isValid() ? date.valueOf() : -Infinity
          }
          const sorted = [...list].sort((a, b) => timeValue(b) - timeValue(a))
          mainItem = sorted[0] // más cercana a hoy
          previousItem = sorted[1] // segunda más cercana a hoy
        }

        setValue('bookingItem', mainItem)
        setValue('previousBooking', previousItem)
        setValue('CamaId', mainItem.CamaId)
        setValue('HuespedId', mainItem.HuespedId)
        setValue('ReservaId', mainItem.ReservaId)
        setValue('Estado', mainItem.Estado)
        setValue('ReservaCamaId', mainItem.ReservaCamaId)
        setValue('hasBookings', true)
      }
    } catch (error) {
    } finally {
      setValue('loadingBooking', false)
    }
  }

  const handleGetGuest = async () => {
    setSearching(true)
    try {
      let modificateString = numeroDocumento
      if (validateString && tipoDocumento === '00') {
        const {ValorBase, TipoDato, Direccion, ActivaExpresion, Expresion} = validateString
        if (ActivaExpresion) {
          const expresion = configDocStringExpresion(Expresion, numeroDocumento)
          if (expresion) {
            modificateString = expresion
            setValue('numeroDocumento', modificateString)
          } else {
            ShowSnackBar('Expresion Regular invalida', 'error')
            setSearching(false)
            return
          }
        } else {
          modificateString = configDocString(numeroDocumento, ValorBase, Direccion, TipoDato)
          setValue('numeroDocumento', modificateString)
        }
      }
      if (modificateString.length === 0) {
        ShowSnackBar('Número de Documento invalido', 'error')
        setSearching(false)
        return
      }
      // const {data: response} = await searchGuestService({
      //   TipoDocumentoId: tipoDocumento,
      //   NumeroDocumento: modificateString,
      // })
      getChekings(tipoDocumento, modificateString)
      // if (response.data.length > 0) {
      //   await setValue('isGuest', true)
      //   await setValue('AceptaTyC', response.data[0].AceptaTyC)
      //   await setValue('CompaniaId', response.data[0].CompaniaId)
      //   await setValue('ClienteId', response.data[0].ClienteId)
      //   await setValue('SiteId', response.data[0].SiteId)
      //   await getChekings(response.data[0].UsuarioId as any)
      // } else {
      //   await setValue('isGuest', false)
      //   await setValue('AceptaTyC', false)
      // }

      nextStep()
    } catch (error) {
      setSearching(false)
    }
  }

  const handleSubmit = () => {
    setSearching(true)
    handleGetGuest()
    const tDocumento = docType.find((doc) => doc.value === tipoDocumento)
    setValue('tipoDocumento_descripcion', tDocumento?.label)
    setValue('fromStep1', false)
  }

  return (
    <div className='w-100'>
      {/* <div className='mt-3'>
        <p>Tiempo restante: {timer} segundos</p>
      </div> */}
      <div className='pb-10 pb-lg-15'>
        {/* <h2 className='fw-bolder d-flex align-items-center text-dark'>Bienvenido</h2> */}
        <div className='fw-bold fs-6'>Porfavor deslice su tarjeta</div>
      </div>

      <div className='row'>
        <div className='col-lg-12 mb-5'>
          <label>Buscar Huésped (por nombre):</label>
          <AsyncSelect
            cacheOptions
            defaultOptions={false}
            loadOptions={debouncedLoadOptions}
            classNamePrefix='react-select'
            noOptionsMessage={() => 'Escribe al menos 3 caracteres para buscar'}
            placeholder='Escribe el nombre del huésped...'
            value={selectedGuest}
            onChange={handleGuestSelect}
            styles={{
              control: (provided: any) => ({
                ...provided,
                width: '98%',
                minHeight: '38px',
              }),
              menuPortal: (provided: any) => ({
                ...provided,
                zIndex: 9999,
              }),
            }}
            menuPortalTarget={document.body}
            isClearable
          />
        </div>

        <div className='col-lg-12'>
          <label className='required'>Tipo de Doc. Id.:</label>
          <Select
            control={control}
            name='tipoDocumentoId'
            data={docType}
            errors={errors}
            // disabled={isDisabled}
          />
        </div>

        <div className='col-lg-12'>
          <label className='required'>Número de Doc. Id.:</label>
          <InputNumberDoc
            name='numeroDocumento'
            textPlaceholder='Escribe el nro de documento'
            register={register}
            errors={errors}
            //   disabled={isDisabled}
            onChange={handleGetPerson}
            typeDoc={watch('tipoDocumentoId')}
            autoFocus={true}
          />
          {/* <input
                type={'text'}
                className='form-control sdx-centra-input-form'
                {...register('numeroDocumento')}
              /> */}
        </div>
        {/* <pre>{JSON.stringify(watch(), null, 2)}</pre> */}
      </div>
      <div className='d-flex flex-stack pt-15 justify-content-between'>
        <button
          type='button'
          className='btn btn-lg btn-light-primary me-3'
          data-kt-stepper-action='previous'
          onClick={() => goToStep(1)}
        >
          Atras
        </button>
        <button
          type='button'
          className='btn btn-lg btn-primary me-3'
          onClick={handleSubmit}
          disabled={searching}
        >
          {!searching && <span className='indicator-label'>Buscar Reserva</span>}
          {searching && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Buscando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </div>
  )
}

export {FormStep2}
